import React, { useState } from 'react';
import { CustomerDetails } from '../../components/iqbd/CustomerDetails';
import useIQBDForm from '../../components/iqbd/useIQBDForm';
import { FORM_TYPE, FORM_TYPE_ACTION_BUTTON_TYPES } from '../../components/iqbd/Form';
import useContentMgmt from '../../hooks/useContentMgmt';
import AuthLayout from '../../components/auth-layout';
import colors from '../../themes/main-colors';

import { Box, Button, Checkbox, FormControlLabel, FormHelperText, Grid, List, ListItem, TextField, Typography, useTheme } from '@material-ui/core';
import makeStyles from '@material-ui/styles/makeStyles';
import CurrencyTextField from '../../components/currency-text-field';
import { SelectDropdown } from '../../components/iqbd/Form/SelectDropdown';
import { Info } from '@material-ui/icons';
import { RadioOption } from '../../components/iqbd/Form/RadioOption';
import { C2MPreferredLanguages } from '../../util/languageUtil';
import { navigate } from 'gatsby';
import ROUTES from '../../routes';
import { IqbdEnrollIneligibilityReason, IqbdEnrollInput, IqbdOperations } from '../../__generated__/pge-types';
import iqbdFormStateAdapter from '../../components/iqbd/utils/iqbdFormStateAdapter';
import { IQBDModel } from '../../components/iqbd/IQBDForm.rules';
import useWrapWithLoader from '../../hooks/useWrapWithLoading';
import useUtil from '../../components/need-more-time-to-pay/useUtil';
import { IQBD_HEADER_CARD_TYPES } from '../../components/iqbd/IQBDHeaderCard';
import IQBDPublicForm from '../../components/iqbd/IQBDPublicForm';
import RichText from '../../components/rich-text';

const useStyles = makeStyles(() => ({
    applyingForBox: {
      border: `1px solid ${colors.lightGray}`,
      backgroundColor: colors.white,
      borderRadius: '16px',
      padding: '48px 0',
      width: '333px',
      textAlign: 'center',
      fontSize: '18px',
      cursor: 'pointer',
      fontFamily: 'Untitled-Sans',
      transition: 'all 0.2s',
    },
    selectedApplyingForBox: {
      background: colors.riverBlue,
      boxShadow: '0px 3px 6px #0000004D',
      fontWeight: 500,
    },
    miniApplyingForBox: {
      padding: '12px',
    },
    formSection: {
      background: `${colors.white} 0% 0% no-repeat padding-box`,
      borderRadius: '5px',
      padding: '30px 20px',
      margin: '10px 0',
    },
    sectionHeading: {
      fontFamily: 'Forma-DJR-Display',
      fontWeight: 'bold',
      fontSize: '24px',
      lineHeight: '28px',
      letterSpacing: '0.48px',
      color: colors.lightCyan,
      marginBottom: '15px',
    },
    sectionInfo: {
      fontFamily: 'Untitled-Sans',
      fontSize: '16px',
      lineHeight: '20px',
      color: colors.lightCyan,
      display: 'block',
      margin: '5px 0',
      '&:last-child': {
        marginBottom: 0,
      },
    },
    highlighted: {
      textDecoration: 'underline',
      fontWeight: 'bold',
      color: colors.sparkBlue,
      cursor: 'pointer',
      fontSize: 'inherit',
      lineHeight: 'inherit',
    },
    button: {
      borderRadius: '5px',
      padding: '13px 57px',
      fontWeight: 'bold',
      fontSize: '18px',
      fontFamily: 'Untitled-Sans',
      display: 'block',
      '&:hover': {
        boxShadow: 'none',
      },
    },
    listItem: {
      display: 'list-item',
      padding: 0,
      fontSize: '16px',
      lineHeight: '20px',
      fontFamily: 'Untitled-Sans',
      margin: '8px 0',
    },
  }));
 
export default function Form() {
     const IQBD_FORM_MICROGROUP_COPY_ID = '6wxqSYOBj1ybyYgyRPeQOA';
          const { content, richText } = useContentMgmt(IQBD_FORM_MICROGROUP_COPY_ID);
         
const title = content.get('PAGE_TITLE');
      
  return (<AuthLayout title={title} showLeft={false} footer={<></>}>
    <IQBDPublicForm content={content} richText={richText}/></AuthLayout>);
}
